module.exports = __webpack_public_path__ + "fe122bdfc2fce7fa5b05820263fcd3f5.mp4";